// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3JtAx","bigColWidth":"Table_bigColWidth__2py0_","biggerColWidth":"Table_biggerColWidth__KDAAS","row":"Table_row__YGxzx","col":"Table_col__Z5TwC"};